<template>
  <b-card class="rounded-lg">
    <lab-results-modal
    :uploads="labUploadData"
    :is-add-active.sync="toggleModal"
    />

    <template #header>
      <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
        <h4 class="text-dark m-0">
          Lab Results
        </h4>
      </div>
    </template>
    

    <div class="no-card-body">
      <div v-if="getValueFromSource(consultationData, 'lab_requests', []) && getValueFromSource(consultationData, 'lab_requests', []).length">
        <div v-for="labRequest in getValueFromSource(consultationData, 'lab_requests', [])" :key="labRequest._id" class="mb-2">
          <div class="d-flex justify-content-between align-items-center bg-light-primary px-2 pt-1" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
            <h6 v-b-toggle="`collapse-${labRequest._id}`" class="text-dark">{{ getValueFromSource(labRequest, 'lab_category.title') }}</h6>
            
            <p v-b-toggle="`collapse-${labRequest._id}`" class="text-muted">
              {{ formatDate(labRequest.created) }}

              <span class="d-inline-block ml-2 when-closed">
                <feather-icon icon="ChevronDownIcon" size="20" />
              </span>

              <span class="d-inline-block ml-2 when-open">
                <feather-icon icon="ChevronUpIcon" size="20" />
              </span>
            </p>
          </div>

          <b-collapse :id="`collapse-${labRequest._id}`" class="">
            <b-card class="" style="background-color: #F5FAFD; border-radius: 0;">
              <div class="mb-2">
                <label>Doctor Note</label>
                <p class="card-text">{{ labRequest.doctor_note || '-' }}</p>
              </div>

              <div class="mb-2">
                <label>Diagnostic Note</label>
                <p class="card-text">{{ labRequest.lab_note || '-' }}</p>
              </div>

              <div class="mb-2">
                <label>Lab Types ({{ getValueFromSource(labRequest, 'lab_types', []).length }})</label>

                <div class="d-flex align-items-center flex-wrap">
                  <p 
                    v-for="labType in getValueFromSource(labRequest, 'lab_types', [])" 
                    :key="labType._id" 
                    class="d-inline-block mr-2"
                    target="_blank"
                  >
                    {{ labType.name }}
                  </p>
                </div>
              </div>

              <div class="mb-2">
                <label>Lab Reports ({{ getValueFromSource(labRequest, 'lab_uploads', []).length }})</label>

                <div class="d-flex align-items-center flex-wrap">
                  <b-link 
                    v-for="labReport in getValueFromSource(labRequest, 'lab_uploads', [])" 
                    :key="labReport._id" 
                    :href="labReport.path"
                    class="d-inline-block mr-2"
                    target="_blank"
                  >
                    <b-img v-if="getExt(labReport.path) !== 'pdf'" :src="labReport.path" style="width: 100px; height: 100px;" />
                    <b-img v-else src="@/assets/images/download-pdf-icon.webp" style="width: 100px; height: 100px;" />
                  </b-link>
                </div>
              </div>
            </b-card>
          </b-collapse>
        </div>
      </div>

      <div v-else>
        <p class="lead">None at the moment.</p>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BImg,
  BRow,
  BCol,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BLink,
  VBToggle,
  BCollapse,
  BDropdown,
  BDropdownItem,
  BDropdownGroup
} from 'bootstrap-vue'

import { formatDate } from '@/@core/utils/utils';
import LabResultsModal from '@core/components/shared/admin/modals/LabResultsModal.vue';

import UserViewActionCard from "./UserViewActionCard.vue";


export default {
  components: {
    BImg,
    BRow,
    BCol,
    BCard,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BLink,
    BCollapse,
    BDropdown,
    BDropdownItem,
    BDropdownGroup,

    UserViewActionCard,
    LabResultsModal
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: {
    consultationData: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      toggleModal: false,
      labUploadData: null,
    }
  },
  methods: {
    formatDate,
    onViewUploads(lab_request){
      this.toggleModal = true
      this.labUploadData = lab_request.lab_uploads
    },
    getExt(link) {
      return link.split(/[#?]/)[0].split('.').pop().trim();
    }
  },
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}

.word-wrap {
  word-wrap: break-word;
  width: 80%;
  border: 2px solid red;
}
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none !important;
}
</style>
